import type { IPropertyAccessorService, PropertyReadTarget } from "./accessor.js";

/** A reusable read operation. The current owner is supplied at use time. */
export interface PropertyReadDefinition {
    read(target: PropertyReadTarget, accessors: IPropertyAccessorService): unknown;
}

export const memberReadDefinition: PropertyReadDefinition = Object.freeze({
    read(target: PropertyReadTarget, accessors: IPropertyAccessorService): unknown {
        return accessors.readValue(target);
    },
});

export function methodReadDefinition(method: string): PropertyReadDefinition {
    return Object.freeze({
        read({ owner }: PropertyReadTarget): unknown {
            const callable = Reflect.get(owner, method);
            if (typeof callable !== "function") throw new TypeError(`Property method '${method}' is not callable`);
            return Reflect.apply(callable, owner, []);
        },
    });
}
